/* Generic viewer for attachments
 * Supports S3 attachments
*/
<template>
  <div>
    <loading-spinner v-if="isLoadingSpinner"></loading-spinner>
    <div v-for="attachment in attachments" :key="attachment.fileId" class="attachment-group">
      <div class="attachment-div">
        <img src="@/assets/images/AttachmentsIcon.png">
        <span
          :title="attachment.fileName"
          style="word-break: break-word;"
        >{{truncateName(attachment.fileName)}}</span>
        <span class="text-right">{{(fileSizeInMB(attachment.fileSize))}} MB</span>
        <font-awesome-icon icon="eye" v-if="viewFileAttachment" :class="[viewFileAttachment ? 'mr-2 fa-lg toggle-attachmentViewForPdf' : null]" @click="viewAttachment(attachment)"></font-awesome-icon>
        <img
          class="clickable"
          src="@/assets/images/AttachmentsDelete.png"
          @click="onDeleteClicked(attachment)"
          v-if="!isPreviewMode">
      </div>
    </div>
  </div>
</template>


<script>
import api from "../../api";
import LoadingSpinner from "@/components/LoadingSpinner";
import  CONSTANTS from "@/store/constants";
import {mapMutations} from "vuex";
export default {
  name: "attachments-viewer",
  props: ["attachments","isPreviewMode","viewFileAttachment"],
  components: { LoadingSpinner },
  data(){
    return{
      isLoadingSpinner: false,
    }
  },
  methods: {
    ...mapMutations(["setErrorMessage"]),
    // Needs to truncate fileName for View to accommodate attachment Actions
    fileSizeInMB(filesize) {
      return (filesize/1000000).toFixed(2)
    },
    truncateName(attachmentName) {
      if (attachmentName) {
        if (attachmentName.length > this.CONSTANTS.FILE_NAME_TRUNCATE_LENGTH) {
          return attachmentName.substring(0, 102).concat("...");
        }
      }
      return attachmentName;
    },
    onDeleteClicked(attachment) {
      this.$emit("onFileDeleted", attachment);
    },
    viewAttachment(attachment){
      if (this.viewFileAttachment){
        this.isLoadingSpinner = true;
        api.getPresignedUrl(attachment.fileId,true)
            .then((response) => {
              window.open(response.data.data.fetchAttachmentPreSignedUrl.preSignedUrl,"_blank");
            }).catch(() => {
          this.setErrorMessage(CONSTANTS.ERROR_MESSAGE)
        }).finally(() => {
          this.isLoadingSpinner = false
        });
      }
    }
  }
};
</script>

<style scoped>

.toggle-attachmentViewForPdf{
  cursor: pointer;
}
.attachment-div {
  background: #ebf0f4;
  border: 1px solid #dee3e7;
  display: flex;
  align-items: center;
  flex-direction: row;
  display: flex;
  flex-grow: 1;
}
.attachment-div * {
  margin: 3px 5px;
}
.attachment-div span {
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
.copy-link img {
  padding-left: 5px;
}

.target-icon-lnk {
  cursor: pointer;
}
.attachment-div img {
  width: 24px;
  opacity: 0.6;
}
.attachment-div img.clickable:hover {
  cursor: pointer;
  opacity: 1;
}
.attachment-group {
  display: flex;
  flex-direction: row;
  margin: 0.5em 0px;
  align-items: center;
}
.attachment-more {
  font-size: 14px;
  text-align: right !important;
}

.attachment-div img.clickable:hover {
  cursor: pointer;
  opacity: 1;
}

@media screen and (max-width: 770px) {
  .attachment-group {
    flex-direction: column;
  }

  .attachment-date {
    margin: 0.3em 0px;
  }

  .attachment-group {
    align-items: flex-start;
  }

  .attachment-div,
  .attachment-date {
    width: 100%;
  }
}
</style>